import "./AssistantTemplatesStyle.scss";
import Reports from "../reports/Reports";
import { useChatStore } from "./stores/ChatStore";

export const AssistantTemplates = () => {
  const { productName } = useChatStore((state) => state.productConfig);
  return (
    <Reports
      reportType={"generative"}
      hideReportButton={true}
      title={`${productName} Templates`}
      description={"Upload your documents to generate AI-powered content"}
    />
  );
};
